import React, { useEffect, useMemo, useState } from "react";
import { RiArrowDropRightLine } from "react-icons/ri";
import { IoIosArrowBack, IoMdClose } from "react-icons/io";
import { BiExitFullscreen, BiFullscreen } from "react-icons/bi";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  closeFullScreen,
  openFullScreen,
  storeGameConfig,
} from "../../../redux/action/game/gameAction";
import { languageTransfer } from "../../../utils/languageTransfer";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import useGetNowGame from "../../../hook/useGetNowGame";
import ToggleFavorite from "../../../components/Favorite/ToggleFavorite";
import LoadingLine from "../../../components/Loading/LoadingLine";
import useGameIsHasDescription from "../gameDescription/gameIsHasDescription";
import { openGameDescriptionPop } from "../../../redux/action/member/memberAction";
import { FaScroll } from "react-icons/fa";
import { Box, Flex, Icon, Text, useColorModeValue } from "@chakra-ui/react";
import { COMMON_WEB_PATH } from "../../../constant";
import UseGetGameBoxBackPathV2 from "../../../hook/useGetGameBoxBackPath_v2";
import useCheckLogin from "../../../hook/useCheckLogin";
import PCToolTab from "./PCToolTab";
import useTransferMode from "../../../hook/useTransferMode";
import { transferAllIn } from "../../../api/postApi";
import { TbTransferVertical } from "react-icons/tb";
import TransferButton from "./TransferInGame/transferButton";
import useGames from "../useGames";

const GameBoxHeader = () => {
  const { t } = useTranslation();
  const i18n_common = (key) => t(`common.${key}`);

  const nowGameConfig = useGetNowGame();

  const dispatch = useDispatch();

  const getPrevPath = UseGetGameBoxBackPathV2();

  const [hiddenHeader, setHiddenHeader] = useState(false);

  const { to } = useParams();

  const { handleExitGame } = useGames();

  useEffect(() => {
    dispatch(storeGameConfig(nowGameConfig));
  }, [nowGameConfig]);

  const isOpenFullScreen = useSelector((state) => state.isOpenFullScreen);

  const navigate = useNavigate();

  const textColor = useColorModeValue("light.100", "light.100");

  const gameConfig = useSelector((state) => state.isGameConfig);

  const { game_platform, game_subtype, SubPlatformEnum } = gameConfig || {};

  const gameIsHasDescription = useGameIsHasDescription({ game_platform });

  const gameName = useMemo(() => {
    return gameConfig?.[
      `gameName${languageTransfer({ lang: i18next.language })}`
    ];
  }, [gameConfig, i18next.language]);

  const { isMachineUser } = useCheckLogin();

  useEffect(() => {
    if (isOpenFullScreen) {
      setHiddenHeader(true);
    } else {
      setHiddenHeader(false);
    }
  }, [isOpenFullScreen]);

  return (
    <>
      <PCToolTab
        setHiddenHeader={setHiddenHeader}
        hiddenHeader={hiddenHeader}
      />
      {/* {!hiddenHeader && (
        <Flex
          w="100%"
          alignItems={`center`}
          justifyContent={`space-between`}
          py="8px"
          px="20px"
          h="52px"
          minH="52px"
          bgImage={`linear(to-b,#AD8D70,#E3D4BA,#7C6150)`}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100%100%"
        >
          {" "}
          <Box as="section" fontWeight={`semibold`} color="brand.500">
            <Box
              as="section"
              mb="0"
              fontSize="xl"
              display={`flex`}
              alignItems={`center`}
            >
              {isOpenFullScreen && (
                <Box
                  minW={"48px"}
                  h={"52px"}
                  rounded={"5px"}
                  gap={"10px"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  cursor="pointer"
                  className={`!flex`}
                  color="white"
                  onClick={() => {
                    setHiddenHeader(true);
                  }}
                >
                  {" "}
                  <IoIosArrowBack className="text-2xl" />
                </Box>
              )}
              <Text as="span" color="white">
                <LoadingLine
                  className={`min-w-[100px] !mt-0`}
                  customInverted={1}
                >
                  {SubPlatformEnum || game_platform}-{i18n_common(game_subtype)}
                </LoadingLine>
              </Text>{" "}
              <Icon color="white" as={RiArrowDropRightLine} fontSize="2xl" />
              <Text as="span" color="white">
                <LoadingLine
                  className={`min-w-[100px] !mt-0`}
                  customInverted={1}
                >
                  {gameName}
                </LoadingLine>
              </Text>
            </Box>
          </Box>
          <Flex
            alignItems={`center`}
            gap="10px"
            fontSize="3xl"
            color="light.600"
            position="relative"
          >
            {!isMachineUser && ( //機台使用者不顯示
              <ToggleFavorite />
            )}
            {isOpenFullScreen ? (
              <Icon
                onClick={() => {
                  dispatch(closeFullScreen());
                }}
                cursor="pointer"
                as={BiExitFullscreen}
                fontSize="2xl"
                color={textColor}
              />
            ) : (
              <Icon
                onClick={() => {
                  dispatch(openFullScreen());
                }}
                cursor="pointer"
                as={BiFullscreen}
                fontSize="2xl"
                color={textColor}
              />
            )}
            {gameIsHasDescription && (
              <Icon
                onClick={() => {
                  dispatch(
                    openGameDescriptionPop({
                      game: game_platform,
                    })
                  );
                }}
                cursor="pointer"
                as={FaScroll}
                fontSize="2xl"
                color={textColor}
              />
            )}
            <Icon
              onClick={() => {
                handleExitGame();
              }}
              cursor="pointer"
              as={IoMdClose}
              fontSize="2xl"
              color={textColor}
            />
          </Flex>
        </Flex>
      )} */}
    </>
  );
};

export default GameBoxHeader;
